import { isAuditEnabled } from '@app/modules/audit/helpers';
import { useMemo } from 'react';
import { useStations } from '../../../core/stations/hooks/useStations';

export function useStationsWithAudit() {
  const stations = useStations();

  return useMemo(() => stations.filter(isAuditEnabled), [stations]);
}
